import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    status: "all", // all | process | ready | completed |
    author: "all"
}

export const ordersFiltersSlice = createSlice({
    name: "filters",
    initialState,
    reducers: {
        setStatus: (state, action) => {
            state.status = action.payload
        },
        setAuthor: (state, action) => {
            state.status = action.payload
        },
    }
})

export const {
    setStatus,
    setAuthor,
} = ordersFiltersSlice.actions